import script from "./Statistics.vue?vue&type=script&setup=true&lang=js"
export * from "./Statistics.vue?vue&type=script&setup=true&lang=js"

import "./Statistics.vue?vue&type=style&index=0&id=c5a34d4c&scoped=true&lang=scss"

import exportComponent from "F:\\hwx\\proj\\vscode\\twzc_system_web\\dataV\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c5a34d4c"]])

export default __exports__